<template>
    <div>
        <loading v-if="loadingRender"></loading>
         <div class="row">
      <div class="card p-3 m-3 w-100" id="Date">

        <div class="row">
          <span class="alert alert-dark w-100 p-2 m-2 text-center">لطفا پارامترهای خود را انتخاب کرده و سپس گزینه
            <span class="text-success">جستجو</span> را بزنید
          </span>
        </div>
        <div class="row">
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>   تاریخ حواله </small>
            <date-picker :editable="true" :auto-submit="true"  color="rgb(94 163 30)" v-model="TarikhAz" >
            </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr"  />
          </div>

          <div class="col-md-4 col-12 mt-2  text-right">
            <small>شماره شبا</small>
            <input type="text" name="name" value="" id="Iban" style="direction: ltr" autocomplete="off" class="form-control" v-model="Iban"  />
          </div>

          <div class="col-md-2 col-12 mt-3">
            <input type="button" name="" value="سرور شماره 1" class="btn btn-success mt-2 w-100" @click="Getreport('1')" />
          </div>
          <div class="col-md-2 col-12 mt-3">
            <input type="button" name="" value="سرور شماره 2" class="btn btn-success mt-2 w-100" @click="Getreport('2')" />
          </div>
          <div class="col-md-2 col-12 mt-3">
            <export-excel :data="exceltable">
              <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel">
                دانلود فایل اکسل
              </i>
            </export-excel>
          </div>
        </div>

      </div>
         </div>
         <div class="card p-3 m-3 w-100" id="Date2">
            <vue-bootstrap4-table  :rows="rows" :columns="columns" :config="config" :classes="classes" :actions="actions" @on-download="Download">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="amount" slot-scope="props">
        {{$Comma3ragham(props.row.amount)}}
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
    </vue-bootstrap4-table>
         </div>
        
    </div>
</template>
<script>
 import VueBootstrap4Table from "vue-bootstrap4-table";
 import loading from "../Tools/NetPa/Loading.vue";

export default {
    data(){
        return{
            DataAxiosRow: {ArryfildValue: "",Method: "Post",Action: "TransactionService",Token: "",},
            TarikhAz:'',
            exceltable:[],
            Iban:'',
            rows: [],
            columns: [{
            label: "id",
            name: "id",
            visibility: false,
          },

          {
            label: "شماره رهگیری",
            name: "internalReferenceId",
          },
          {
            label: "تاریخ",
            name: "draftDate",
          },
          {
            label: "زمان",
            name: "transactionTime",
          },
          {
            label: "مبلغ تراکنش",
            name: "amount",
          },
          {
            label: "شماره کارت",
            name: "pan",
          },
          {
            label: "شماره حواله واریز",
            name: "draftNumber",
          },
          
            ],
            actions: [{
            btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
            event_name: "on-download",
            class: "btn  mx-2 btn-outline-success rounded btnEXL ",
            event_payload: {msg: "my custom msg",},
            }],
            config: {
                pagination: false,
                pagination_info: false,
                per_page_options: [10, 20, 30, 50, 100],
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                card_title: "",
                card_mode: false,
                global_search: {
                    placeholder: " جستجو",
                    visibility: true,
                    case_sensitive: false,
                    showClearButton: true,
                    searchOnPressEnter: false,
          },
            },
            classes: {
            table: "table-bordered table-striped table-sm ",
            },
            loadingRender: false,
        }
    },
    components: {
      VueBootstrap4Table,loading
    },
    methods:{
        Getreport(server){
          
            this.rows = [];
            this.loadingRender=true;
            let info;
            let list = [];
            const formData = new FormData();
        formData.append('refNo',this.Iban);
        formData.append('Date',this.TarikhAz);
        formData.append('Server',server);
        this.DataAxiosRow.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosRow).then((data) => {
            if(data.length>0){
                if (data.length > 10) {
                        this.config.pagination = true;
                      } else {
                        this.config.pagination = false;
                      }
                      for (let index = 0; index < data.length; index++) {
                        info = data[index];
                        list.push(info);
                      }
                      this.loadingRender=false;
                      this.rows = this.$FormatMablaghGrid(list);
                      this.exelReport(this.rows);
            }else{
                this.loadingRender=false;
                  this.$mySweetDefaultTost(
                      "عدم وجود اطلاعات",
                      "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
                      "info",
                      2000
                    );
                    this.config.pagination = false;
                    this.rows = [];
            }
            
        });
        },
        Download() {
        document.getElementById("DownloadExcel").click();
      },
       exelReport(rows) {
        this.exceltable = [];
        rows.forEach((element) => {
          var excelrow = {
            "شماره رهگیری": element.internalReferenceId,
            "تاریخ": element.draftDate,
            "زمان": element.transactionTime,
            "مبلغ تراکنش": element.amount,
            "شماره کارت": element.pan,
            "شماره حواله واریز": element.draftNumber,
          };

          this.exceltable.push(excelrow);
        });
        // console.log( this.exceltable);
      },
    }

}
</script>
<style scoped>

</style>